import React, { useState, useMemo } from 'react';
import { Container, Col } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const MerknaderEiendomTable = (props) => {

    const localeMessages = props.localeMessages
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('documentNumber');    // feltnavn
    const [currentType, setCurrentType] = useState('string'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);

    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )
    
    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
          <thead>
              <tr>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('id', 'string')}>{localeMessages['GH_id']}{t1IndicaterIcon('id')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registeredDate', 'string')}>{localeMessages['GH_registeredDate']}{t1IndicaterIcon('registeredDate')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('registeredOnMultipleProperties', 'string')}>{localeMessages['GH_registeredOnMultipleProperties']}{t1IndicaterIcon('registeredOnMultipleProperties')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('directResponsibility', 'string')}>{localeMessages['GH_directResponsibility']}{t1IndicaterIcon('directResponsibility')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('caseNumber', 'string')}>{localeMessages['GH_caseNumber']}{t1IndicaterIcon('caseNumber')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('legalFoundation', 'string')}>{localeMessages['GH_legalFoundation']}{t1IndicaterIcon('legalFoundation')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('freeText', 'string')}>{localeMessages['GH_freeText']}{t1IndicaterIcon('freeText')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('districtCourt', 'string')}>{localeMessages['GH_districtCourt']}{t1IndicaterIcon('districtCourt')}</th>
                  <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('estateManager', 'string')}>{localeMessages['GH_estateManager']}{t1IndicaterIcon('estateManager')}</th>
              </tr>
          </thead>
      )
    }


    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.id}</KredittvurderingTd>
               <KredittvurderingTd>{model.registeredDate}</KredittvurderingTd>
               <KredittvurderingTd>{model.registeredOnMultipleProperties}</KredittvurderingTd>
               <KredittvurderingTd>{model.directResponsibility}</KredittvurderingTd>
               <KredittvurderingTd>{model.caseNumber}</KredittvurderingTd>
               <KredittvurderingTd>{model.legalFoundation}</KredittvurderingTd>
               <KredittvurderingTd>{model.freeText}</KredittvurderingTd>
               <KredittvurderingTd>{model.districtCourt}</KredittvurderingTd>
               <KredittvurderingTd>{model.estateManager}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Merknader om eiendomstvangsforretning</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default MerknaderEiendomTable



